<template>
    <el-card>
        <div class="title">支付配置</div>
        <el-form ref="form" :rules="rules" :model="form">
            <el-form-item label="区域名称" required prop="area_id">
                <el-select
                    v-show="mecSelect"
                    v-model="form.area_id"
                    :disabled="form.id ? true : false"
                    placeholder="请选择"
                >
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商户名称" required prop="name">
                <el-input v-model="form.name" />
            </el-form-item>
            <el-form-item label="支付类型" required prop="type">
                <el-radio-group v-model="form.type">
                    <!-- <el-radio
                        v-for="(item, index) in typeList"
                        :key="index"
                        :label="item.id"
                        >{{ item.name }}</el-radio
                    > -->
                    <el-radio :label="1" :disabled="form.id ? true : false"
                        >微信支付</el-radio
                    ><el-radio :label="3" :disabled="form.id ? true : false"
                        >天阙支付</el-radio
                    >
                </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="上传文件"> -->
            <div v-if="form.type == 1" class="form-body">
                <!-- 微信支付
                    <div class="text-label"></div>
                    <div class="text-input">
                        <el-input v-model="weixin.pay_mch_id"></el-input>
                    </div> -->
                <el-form-item label="小程序appid" required>
                    <el-input v-model="form.param.app_id"></el-input>
                </el-form-item>
                <el-form-item label="商户号" required>
                    <el-input v-model="form.param.mch_id"></el-input>
                </el-form-item>
                <el-form-item label="API密钥" required>
                    <el-input v-model="form.param.mch_key"></el-input>
                </el-form-item>
                <el-form-item label="PayCertPath" required>
                    <el-upload
                        :before-upload="beforePayUpload"
                        :data="uploadData"
                        :headers="uploadHeaders"
                        :on-success="handlePayCertPathSuccess"
                        :show-file-list="false"
                        accept="pem"
                        action="/admin-api/pay-merchants/uploadPayCert?type=1"
                        class="avatar-uploader"
                        name="file"
                    >
                        <el-button
                            v-if="form.param.pay_cert_path"
                            type="primary"
                            >已上传
                        </el-button>
                        <el-button v-else type="danger">上传文件 </el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="PayKeyPath" required>
                    <el-upload
                        :before-upload="beforePayUpload"
                        :data="uploadData"
                        :headers="uploadHeaders"
                        :on-success="handlePayKeyPathSuccess"
                        :show-file-list="false"
                        action="/admin-api/pay-merchants/uploadPayCert?type=1"
                        class="avatar-uploader"
                        name="file"
                    >
                        <el-button v-if="form.param.pay_key_path" type="primary"
                            >已上传
                        </el-button>
                        <el-button v-else type="danger">上传文件 </el-button>
                    </el-upload>
                </el-form-item>
            </div>
            <div v-if="form.type == 3" class="form-body">
                <!-- 天阙
                    <div class="text-label"></div>
                    <div class="text-input">
                        <el-input v-model="weixin.pay_mch_id"></el-input>
                    </div> -->
                <el-form-item label="小程序appid" required>
                    <el-input v-model="form.param.app_id"></el-input>
                </el-form-item>
                <el-form-item label="商户编号" required>
                    <el-input v-model="form.param.mno"></el-input>
                </el-form-item>
                <el-form-item label="机构编号" required>
                    <el-input v-model="form.param.orgId"></el-input>
                </el-form-item>
                <el-form-item label="商户证书pub" required>
                    <!-- :before-upload="beforePayUpload" -->
                    <el-upload
                        :data="uploadData"
                        :headers="uploadHeaders"
                        :on-success="handlePayCertPathSuccessTianque"
                        :show-file-list="false"
                        action="/admin-api/pay-merchants/uploadPayCert?type=3"
                        form.type
                        class="avatar-uploader"
                        name="file"
                    >
                        <el-button
                            v-if="form.param.pay_cert_path"
                            type="primary"
                            >已上传
                        </el-button>
                        <el-button v-else type="danger">上传文件 </el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="商户证书pri" required>
                    <!--  -->
                    <el-upload
                        :data="uploadData"
                        :headers="uploadHeaders"
                        :on-success="handlePayKeyPathSuccessTianque"
                        :show-file-list="false"
                        action="/admin-api/pay-merchants/uploadPayCert?type=3"
                        class="avatar-uploader"
                        name="file"
                    >
                        <el-button v-if="form.param.pay_key_path" type="primary"
                            >已上传
                        </el-button>
                        <el-button v-else type="danger">上传文件 </el-button>
                    </el-upload>
                </el-form-item>
            </div>
            <!-- 支付宝 -->
            <div v-if="form.type == 2">
                <el-form-item label="支付宝小程序APPID">
                    <el-input v-model="form.param.alipaymini_appId"></el-input>
                </el-form-item>
                <el-form-item label="支付宝应用公钥">
                    <el-input
                        v-model="form.param.alipaymini_merchantPrivateKey"
                        :rows="12"
                        type="textarea"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="支付宝接口内容加密解密AES"
                    label-width="300"
                >
                    <el-input
                        v-model="form.param.alipaymini_aesKey"
                        style="width: 30%"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="支付宝支付证书alipayCertPublicKey_RSA2.crt"
                    label-width="300"
                    required
                >
                    <!--                            支付宝支付证书-->
                    <el-upload
                        :before-upload="beforePayUpload"
                        :data="uploadData"
                        :headers="uploadHeaders"
                        :on-success="handlealipaymini_alipayCertPathSuccess"
                        :show-file-list="false"
                        accept="pem"
                        action="/admin-api/pay-merchants/uploadPayCert?type=2"
                        class="avatar-uploader"
                        name="file"
                    >
                        <el-button
                            v-if="form.param.alipaymini_alipayCertPath"
                            type="primary"
                            >已上传
                        </el-button>
                        <el-button v-else type="danger">上传文件 </el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item
                    label="支付宝根证书alipayRootCert.crt"
                    label-width="300"
                    required
                >
                    <!--                            支付宝根证书-->
                    <el-upload
                        :before-upload="beforePayUpload"
                        :data="uploadData"
                        :headers="uploadHeaders"
                        :on-success="handlealipayRootCertPathSuccess"
                        :show-file-list="false"
                        action="/admin-api/pay-merchants/uploadPayCert?type=2"
                        class="avatar-uploader"
                        name="file"
                    >
                        <el-button
                            v-if="form.param.alipaymini_alipayRootCertPath"
                            type="primary"
                            >已上传
                        </el-button>
                        <el-button v-else type="danger">上传文件 </el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item
                    label="支付宝公钥证书appCertPublicKey_2021002113630150.crt"
                    label-width="auto"
                    required
                >
                    <!--                            支付宝公钥证书-->
                    <el-upload
                        :before-upload="beforePayUpload"
                        :data="uploadData"
                        :headers="uploadHeaders"
                        :on-success="handlemerchantCertPathSuccess"
                        :show-file-list="false"
                        action="/admin-api/pay-merchants/uploadPayCert?type=2"
                        class="avatar-uploader"
                        name="file"
                    >
                        <el-button
                            v-if="form.param.alipaymini_merchantCertPath"
                            type="primary"
                            >已上传
                        </el-button>
                        <el-button v-else type="danger">上传文件 </el-button>
                    </el-upload>
                </el-form-item>
            </div>
            <!-- </el-form-item> -->
            <el-form-item label="状态" required prop="status">
                <el-radio-group v-model="form.status">
                    <el-radio :label="1">正常</el-radio
                    ><el-radio :label="0">禁用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="saveForm">{{
                    form.id ? "保存编辑" : "立即添加"
                }}</el-button>
                <el-button @click="cancelSubmit">取消</el-button>
            </el-form-item>
        </el-form>
    </el-card>
</template>
<script>
import {
    // getMerchantConfig,
    // editMerchantConfig,
    getTypeList,
} from "@/api/admin-merchant";
import {
    addPaysMerchants,
    PaysMerchantsDetails,
    updatePaysMerchants,
    getAreasList,
} from "@/api/pay-merchant";
import { getToken } from "@/libs/token";
import FormHelper from "@c/LzForm/FormHelper";
import LzForm from "@c/LzForm";
export default {
    components: {
        LzForm,
    },
    mixins: [FormHelper],
    data() {
        return {
            activeName: "first",
            form: {
                type: 1,
                name: "",
                area_id: "",
                status: 1,
                param: {},
            },
            zhifubao: {},
            weixin: {},
            tianque: {},
            options: [],
            value: "",
            uploadHeaders: {
                Authorization: "",
            },

            uploadData: {
                id: 0,
            },
            typeList: [], //支付类型
            rules: {
                job_number: [
                    {
                        min: 3,
                        max: 6,
                        message: "长度在 3 到 6个字符",
                        trigger: "blur",
                    },
                ],
            },
            errors: {},
            mecSelect: true,
        };
    },
    async created() {
        // this.value = this.$route.query.id;
        this.value = this.getResourceId();

        this.uploadHeaders.Authorization = getToken();
        await this.getAreas();
        if (this.value) {
            await this.getData();
        }
        console.log(this.$store.state.users.user.roles, "校色");
        if (this.$store.state.users.user.roles[0] === "merchantsAdmin") {
            this.mecSelect = false;
        }
    },

    methods: {
        getResourceId(key = "id") {
            return this.$route.params[key];
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        currentSel(selVal) {
            console.log(selVal);
            this.value = selVal;
            this.getData();
        },
        async saveForm() {
            // if (this.form.type == 1) {
            //     this.form.param = [this.weixin];
            // }
            // if (this.form.type == 2) {
            //     this.form.param = [this.zhifubao];
            // }
            // if (this.form.type == 3) {
            //     this.form.param = [this.tianque];
            // }
            if (this.form.id) {
                await updatePaysMerchants(this.form.id, this.form);
                this.cancelSubmit();
            } else {
                await addPaysMerchants(this.form);
                this.cancelSubmit();
            }
        },
        //获取支付类型
        async payTypeList() {
            const res = await getTypeList();
            let types = res.data;
            let arr = [];
            for (let key in types) {
                if (Number(key) !== 2) {
                    arr.push({
                        id: Number(key),
                        name: types[key],
                    });
                }
            }
            this.typeList = arr;
            console.log(res, "支付类型");
        },

        cancelSubmit() {
            this.form = {
                type: 1,
                name: "",
                area_id: "",
                status: 1,
                param: {},
            };
            this.zhifubao = {};
            this.weixin = {};
            this.tianque = {};
            this.$router.push("/pay_merchants");
        },
        async getData() {
            let params = "";
            if (this.value) {
                params = this.value;
            }
            console.log(params, "pppppparams");
            const { data } = await PaysMerchantsDetails(params);
            this.form = data;
            // this.options = data["mch_list"];
            this.value = data["id"];
            this.uploadData.id = this.value;
        },
        //获取区域列表
        async getAreas() {
            const { data } = await getAreasList();
            this.options = data;
        },
        // handleAvatarSuccess(res, file) {
        //     this.form.wxapp_qr_code = res.path;
        // },
        // factory_qr_code_success(res, file) {
        //     this.form.factory_qr_code = res.path;
        // },
        // ground_qr_code_success(res, file) {
        //     this.form.ground_qr_code = res.path;
        // },
        // 微信支付
        handlePayCertPathSuccess(res, file) {
            this.form.param.pay_cert_path = res.path;
            this.$forceUpdate();
        },
        handlePayKeyPathSuccess(res, file) {
            this.form.param.pay_key_path = res.path;
            this.$forceUpdate();
        },
        //天阙支付
        handlePayCertPathSuccessTianque(res, file) {
            console.log(res.path, "resresres");
            this.form.param.pay_cert_path = res.path;
            this.$forceUpdate();
        },
        handlePayKeyPathSuccessTianque(res, file) {
            this.form.param.pay_key_path = res.path;
            this.$forceUpdate();
        },
        handlealipaymini_alipayCertPathSuccess(res, file) {
            //支付宝支付证书
            this.form.param.alipaymini_alipayCertPath = res.path;
        },
        handlealipayRootCertPathSuccess(res, file) {
            //支付宝支付根证书
            this.form.param.alipaymini_alipayRootCertPath = res.path;
        },
        handlemerchantCertPathSuccess(res, file) {
            //支付宝公钥证书
            this.form.param.alipaymini_merchantCertPath = res.path;
        },
        beforePayUpload(file) {
            console.log(file);
            const isPem = file.type === "application/x-x509-ca-cert";
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isPem && this.form.type !== 3) {
                this.$message.error("上传文件只支持pem格式!");
            }
            if (!isLt2M) {
                this.$message.error("上传大小不能超过 2MB!");
            }
            return isPem && isLt2M;
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG && !isPNG) {
                this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!");
            }
            return (isJPG || isPNG) && isLt2M;
        },
    },
};
</script>
<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    /* height: 178px; */
    display: block;
}

.el_child {
    display: inline-block;
    vertical-align: middle;
    width: 40%;
}

.lable-left {
    display: inline-block;
    vertical-align: middle;
    widows: 300 !important;
}

.el-form-item__label1 {
    text-align: left !important;
}
</style>
